export const isChrome = () => {
  if (typeof navigator !== 'undefined') {
    return /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor)
  }
  return false
}
